<template>
  <div class="bind-card-actions">
    <button type="button" class="bind-card-actions__btn bind-card-actions__btn--scan" @click="wxUrlSign">
      <van-icon name="scan" size="1rem" />
      <span>扫码绑卡</span>
    </button>
    <button type="button" class="bind-card-actions__btn bind-card-actions__btn--code" @click="scanAdd">
      <van-icon name="edit" size="1rem" />
      <span>券密绑定</span>
    </button>

    <BindGetKnow v-if="show" :cardDate="cardDate" @closed="closeds" @sured="sured" />
    <GreetingCard
      :visible="showGreetingCard"
      :card-image="currentGreetingCard?.imageUrl"
      :blessing="currentGreetingCard?.blessing"
      :need-signature="currentGreetingCard?.needSignature === '1'"
      @button-click="handleGreetingCardButtonClick"
    />
    <SignaturePad
      :visible="showSignature"
      :signature-options="signatureOptions"
      @close="closeSignature"
      @confirm="handleSignatureConfirm"
    />
  </div>
</template>

<script>
import BindGetKnow from '@/components/card/BindGetKnow';
import GreetingCard from './GreetingCard.vue';
import SignaturePad from './SignaturePad.vue';
import { invokeWechatScan } from '@/utils/wechatScan';

export default {
  name: 'BindCardActions',
  components: { BindGetKnow, GreetingCard, SignaturePad },
  props: {
    ticketType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: false,
      cardDate: null,
      form: {
        qrCodeContent: '',
        userId: '',
        ticketType: '',
        flag: true,
        newTime: 0,
      },
      timeinterval: 1500,
      showGreetingCard: false,
      showSignature: false,
      signatureOptions: {
        penColor: '#000000',
        backgroundColor: '#f5f5f5',
      },
      currentGreetingCard: null,
    };
  },
  mounted() {
    if (localStorage.getItem('userInfo')) {
      this.form.userId = JSON.parse(localStorage.getItem('userInfo')).id;
    }
    this.newTime = 0;
  },
  methods: {
    getTicketType() {
      return this.ticketType || localStorage.getItem('entrCode') || '';
    },
    closeds() {
      this.show = false;
    },
    /** 券密绑定：仍跳转 BindCard 页，表单与接口逻辑不变 */
    scanAdd() {
      this.$router.push({
        path: '/BindCard',
        query: {
          ticketType: this.getTicketType(),
        },
      });
    },
    wxUrlSign() {
      const intTime = new Date().getTime() - this.newTime;
      if (intTime < this.timeinterval) {
        this.$Toast('请不要连续点击');
        return;
      }
      this.newTime = new Date().getTime();
      invokeWechatScan({
        requestSign: (signUrl) => this.$api.wxUrlSign(signUrl),
        onResult: (qrText) => this.onSubmit(qrText),
        onToast: (text) => this.$Toast(text),
      });
    },
    onSubmit(val) {
      this.form.qrCodeContent = val;
      this.form.ticketType = this.getTicketType();
      this.$api
        .checkBenefitCard(this.form)
        .then((res) => {
          if (res.code == 0) {
            this.cardDate = res.data;
            this.show = true;
          } else {
            this.$Toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    sured() {
      this.$api
        .boundBenefitCardByQR(this.form.qrCodeContent, this.getTicketType())
        .then((res) => {
          if (res.code == 0) {
            this.show = false;
            if (this.cardDate && this.cardDate.showGreetingCard === '1') {
              this.currentGreetingCard = this.cardDate;
              this.showGreetingCard = true;
            } else {
              this.$emit('bind-success');
            }
          }
          this.$Toast(res.msg);
        })
        .catch(() => {});
    },
    handleGreetingCardButtonClick() {
      if (!this.currentGreetingCard) return;
      if (this.currentGreetingCard.needSignature === '1') {
        this.showSignature = true;
      } else {
        this.saveGreetingCardSignature(null);
      }
    },
    saveGreetingCardSignature(signatureDataURL) {
      if (!this.currentGreetingCard) return;
      const params = {
        spuId: this.currentGreetingCard.spuId,
        cardId: this.currentGreetingCard.cardId,
      };
      if (signatureDataURL) {
        params.signatureImage = signatureDataURL.includes(',')
          ? signatureDataURL.split(',')[1]
          : signatureDataURL;
      }
      this.$api
        .saveGreetingCardSignature(params)
        .then((res) => {
          if (res.code === 0) {
            this.$Toast.success('签收成功');
            this.showSignature = false;
            this.showGreetingCard = false;
            this.currentGreetingCard = null;
            this.$emit('bind-success');
          } else {
            this.$Toast.fail(res.msg || '签收失败');
          }
        })
        .catch((err) => {
          this.$Toast.fail('签收失败');
          console.error('保存签收记录失败:', err);
        });
    },
    closeSignature() {
      this.showSignature = false;
    },
    handleSignatureConfirm(signatureDataURL) {
      this.saveGreetingCardSignature(signatureDataURL);
    },
  },
};
</script>

<style lang="scss" scoped>
.bind-card-actions {
  display: flex;
  gap: 0.625rem;
  margin-bottom: 0.75rem;
}

.bind-card-actions__btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  height: 2.75rem;
  border-radius: 0.625rem;
  font-size: 0.9375rem;
  font-weight: 500;

  &--scan {
    border: none;
    background: linear-gradient(135deg, #ff8a4c 0%, #d33b2e 100%);
    color: #fff;
    box-shadow: 0 4px 12px rgba(211, 59, 46, 0.22);
  }

  &--code {
    border: 1px solid #d33b2e;
    background: #fff;
    color: #d33b2e;
  }
}
</style>
